import { Suspense, useEffect } from "react";
import AppRouter from "./routers/AppRouter";
import Preloader from "./helper/Preloader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthInitializer from "./redux/auth/AuthInitializer";
import { useDispatch } from "react-redux";
import {
  setCategories,
  setCategoriesError,
  setCategoriesLoading,
} from "./redux/categories/categoriesSlice";
import { fetchCategoriesData } from "./services/categories/categories.services";

function App() {
  const dispatch = useDispatch();
  async function getCategories() {
    dispatch(setCategoriesLoading(true));
    try {
      const result = await fetchCategoriesData();
      if (result.status) {
        dispatch(setCategories(result.data));
      }
    } catch (err) {
      dispatch(setCategoriesError(err.message));
    } finally {
      dispatch(setCategoriesLoading(false));
    }
  }

  useEffect(() => {
    getCategories();
  }, [dispatch]);
  return (
    <AuthInitializer>
      <ToastContainer position="top-right" autoClose={1000} />
      <Suspense fallback={<Preloader />}>
        <AppRouter />
      </Suspense>
    </AuthInitializer>
  );
}

export default App;
